<template>
  <modal
   class="custom-modal" v-model="isEmailPreviewModalOpen" :before-close="beforeClose" ref="modal" :footer="false" size="lg" id="mailPreviewModal"
  >
    <template #header>
      <h3>Podgląd wiadomości</h3>
      <a role="button" href="#" class="custom-modal__close" type="button" @click.prevent="beforeClose">
        <span class="mi mi-cross"></span>
      </a>
    </template>
    <embed width="100%"  :src="linkForProductSampleEmail" alt="mail preview example">
  </modal>
</template>

<script>
export default {
  name: 'virtualCardEmailPreviewModal',
  props: ['isEmailPreviewModalOpen', 'productSlug'],
  methods: {
    beforeClose() {
      this.$emit('handleModalOpen', null);
    },
  },
  computed: {
    linkForProductSampleEmail() {
      switch (this.productSlug) {
        case 'wirtualna-karta-podarunkowa':
          return `${process.env.VUE_APP_BASE_URL}/docs/Email_do-Użytkownika_Wirtualna_Karta_Podarunkowa.pdf`;

        case 'wirtualna-karta-premiowa':
          return `${process.env.VUE_APP_BASE_URL}/docs/Email_do_Użytkownika_Wirtualna_Karta_Premiowa.pdf`;

        case 'wirtualna-karta-lunch-pass':
          return `${process.env.VUE_APP_BASE_URL}/docs/Email_do_uzytkownika_Wirtualna_Karta_Lunch_Pass.pdf`;

        case 'wirtualna-karta-pluxee-lunch':
          return `${process.env.VUE_APP_BASE_URL}/docs/email-pluxee-lunch.pdf`;

        case 'wirtualna-karta-pluxee-prezent-na-swieta':
          return `${process.env.VUE_APP_BASE_URL}/docs/email-pluxee-swieta.pdf`;

        case 'wirtualna-karta-pluxee-nagroda':
          return `${process.env.VUE_APP_BASE_URL}/docs/email-pluxee-nagroda.pdf`;

        case 'wirtualna-karta-pluxee-prezent':
          return `${process.env.VUE_APP_BASE_URL}/docs/email-pluxee-prezent.pdf`;

        case 'karta-wirtualna-pluxee-lunch':
          return `${process.env.VUE_APP_BASE_URL}/docs/email-pluxee-lunch.pdf`;

        case 'karta-wirtualna-pluxee-nagroda':
          return `${process.env.VUE_APP_BASE_URL}/docs/email-pluxee-nagroda.pdf`;

        case 'karta-wirtualna-pluxee-prezent':
          return `${process.env.VUE_APP_BASE_URL}/docs/email-pluxee-prezent.pdf`;

        default:
          return `${process.env.VUE_APP_BASE_URL}/docs/email-pluxee-nagroda.pdf`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #mailPreviewModal {
    embed {
      min-height: 80vh;
    }
  }
</style>
